<div class="container" #organizationTabThree>
  <form [formGroup]="fileForm">

    <div class="d-flex justify-content-end">
      <button
        style="border: none; background: none; padding: 0"
        (click)="openUploadDialog()"
      >
        <a
          href="javascript:void(0);"
          class="btn btn-primary btn-sm content-icon"
        >
          <i class="fa fa-plus"></i>
        </a>
      </button>
    </div>

    <div class="row mt-3">
      <div class="col-xl-12 active-p">
        <div class="tab-content" id="pills-tabContent">
          <div>
            <div bodyContent>
              <ng-container class="table-responsive">
                <table
                  id="dot-tbl"
                  class="table dataTable"
                  aria-describedby="dot-tbl_info"
                >
                  <thead>
                    <tr role="row">
                      <th scope="col">
                        {{ "organization.file-name" | translate }}
                      </th>
                      <th scope="col">
                        {{ "organization.file-description" | translate }}
                      </th>
                      <th scope="col">
                        {{ "organization.file-added-user" | translate }}
                      </th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody
                    *ngIf="
                      fileForm?.value?.uploadedFiles?.length > 0;
                      else empty
                    "
                  >
                    <tr
                      *ngFor="
                        let item of fileForm.value.uploadedFiles;
                        let i = index
                      "
                      role="row"
                      class="odd"
                    >
                      <td>{{ item?.fileName }}</td>
                      <td>{{ item?.fileDescription }}</td>
                      <td >{{showFileCreator(item?.createdBy)}}</td>
                      <td>
                        <button
                          style="
                            border: none;
                            background: none;
                            padding: 0;
                            margin-right: 5%;
                          "
                          (click)="onClickDownload(item)"
                          *ngIf="item?.id"
                        >
                          <a class="btn btn-warning btn-sm content-icon">
                            <i class="fa fa-download"></i>
                          </a>
                        </button>
                        <button
                          style="border: none; background: none; padding: 0"
                          (click)="deleteFileConfirm(item,i)"
                        >
                          <a
                            href="javascript:void(0);"
                            class="btn btn-danger btn-sm content-icon"
                          >
                            <i class="fa fa-times"></i>
                          </a>
                        </button>
                      </td>
                      <td  *ngIf="!item?.id">
                        <span
                          *ngIf="!item?.id"
                          class="badge badge-success ms-2"
                          style="font-size: 10px; vertical-align: middle;"
                        >{{ "general.new" | translate }}</span>
                      </td>
                    </tr>
                  </tbody>
                  <ng-template #empty>
                    <tbody>
                      <tr>
                        <td colspan="6">
                          <app-empty-data
                            [title]="'organization.list-empty' | translate"
                            [message]="'list.list-empty' | translate"
                            icon="mdi mdi-information-outline"
                            containerClass="opacity-50"
                            iconSize="40px"
                            iconColor="gray"
                            titleSize="10px"
                            titleColor="gray"
                            messageSize="14px"
                            messageColor="gray"
                          ></app-empty-data>
                        </td>
                      </tr>
                    </tbody>
                  </ng-template>
                </table>
              </ng-container>

              <!--YENİ EKLER -->
              <!-- <div *ngIf="this.orgId">
                <div class="col-xl-4 mt-3">
                  <h4>{{ "organization.new-files" | translate }}</h4>
                </div>
                <div
                  class="row mb-3"
                  *ngFor="
                    let file of this.fileForm.value.editModeUploadedFiles;
                    let i = index
                  "
                >
                  <div class="col-xl-5">
                    <h5>{{ "organization.file-name" | translate }}</h5>
                    <p>{{ file?.fileName }}</p>
                  </div>
                  <div class="col-xl-4">
                    <h5>{{ "organization.file-description" | translate }}</h5>
                    <p>{{ file?.fileDescription }}</p>
                  </div>
                  <div class="col-xl-2">
                        <button
                          style="border: none; background: none; padding: 0"
                          (click)="deleteEditModeUploadedFiles(i)"
                        >
                          <a
                            href="javascript:void(0);"
                            class="btn btn-danger btn-sm content-icon"
                          >
                            <i class="fa fa-times"></i>
                          </a>
                        </button>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<app-upload-file-upload-dialog
  #organizationFileUploadDialog
  (fileAdded)="onSaveFile($event)"
  [moduleName]="'organization'"
></app-upload-file-upload-dialog>

<app-sweet-alert></app-sweet-alert>
